import { render, staticRenderFns } from "./AccountRequestLists.vue?vue&type=template&id=23f283ef&scoped=true"
import script from "./AccountRequestLists.vue?vue&type=script&lang=js"
export * from "./AccountRequestLists.vue?vue&type=script&lang=js"
import style0 from "./AccountRequestLists.vue?vue&type=style&index=0&id=23f283ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f283ef",
  null
  
)

export default component.exports